import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const ArrowForwardIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="arrow-right" {...props} />;
};

export { ArrowForwardIcon };
